import {
  getLoginUrl,
  subscribeOnLoginFailure,
  subscribeOnLoginSuccess,
  LOGIN_TYPE,
  ESIA_TYPE,
} from '@sravni/utils/lib/auth';

import { EsiaPopupError } from './EsiaPopupError';

interface IEsiaConnectorProps {
  onSuccess: () => void;
  onError: () => void;
  popupWndShowTimeout: number;
  popupSize?: number;
  isStrict?: boolean;
}

export class EsiaConnector {
  private wnd: Nullable<Window> = null;
  private readonly onSuccess: () => void;
  private readonly onError: () => void;
  private readonly popupWndShowTimeout: number;
  private readonly popupSize: number;
  private readonly isStrict?: boolean;

  constructor({ onSuccess, onError, popupWndShowTimeout, popupSize = 754, isStrict }: IEsiaConnectorProps) {
    this.onSuccess = onSuccess;
    this.onError = onError;
    this.popupWndShowTimeout = popupWndShowTimeout;
    this.popupSize = popupSize;
    this.isStrict = isStrict;
  }

  async tryLogin() {
    const url = getLoginUrl({
      returnUrl: window.location.href,
      loginType: LOGIN_TYPE.ESIA,
      esiaType: this.isStrict ? ESIA_TYPE.STRICT : ESIA_TYPE.OPTIONAL,
      isNewWindow: true,
    });

    try {
      await this._tryPopupLogin(url);
    } catch (e) {
      if (e instanceof EsiaPopupError) {
        /**
         * если упали при открытии popup,
         * значит открытие окон заблокировано - пробуем прямой переход
         * */
        return this._tryDirectLogin(url);
      }

      return this.onError();
    }

    this.onSuccess();
  }

  private async _tryPopupLogin(url: string): Promise<void> {
    return new Promise((resolve, reject) => {
      subscribeOnLoginSuccess(() => {
        this.wnd?.close();
        resolve();
      });

      subscribeOnLoginFailure(() => {
        setTimeout(() => {
          this.wnd?.close();
          reject(new Error('auth error'));
        }, this.popupWndShowTimeout);
      });

      // фикс, тк iphone блокирует window.open в асинхронных функциях
      setTimeout(() => {
        const features = this._getSilentAuthModalPosition(this.popupSize);

        this.wnd = window.open(url, '_blank', features);
        if (!this.wnd) {
          reject(new EsiaPopupError());
        }
      }, 0);
    });
  }

  private _getSilentAuthModalPosition(width: number) {
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || window.screen.width;
    const screenHeight = window.innerHeight || document.documentElement.clientHeight || window.screen.height;
    const currentWidth = width < screenWidth ? width : screenWidth;

    return `height=${screenHeight},width=${currentWidth},top=0,right=0`;
  }

  private _tryDirectLogin(url: string) {
    window.location.href = url;
  }
}
